import axios, {AxiosResponse} from 'axios'
import {ID, Response} from 'src/_metronic/helpers'
import {configuration} from 'src/configuration.js'
const API_URL = configuration.apiUrl
const Party_URL = `${API_URL}/party/getPartyListing`
const City_URL = `${API_URL}/cities`
const PARTY_URL = `${API_URL}/party`
const USER_URL = `${API_URL}/users/allUser`
const MESSAGE_URL = `${API_URL}/message`

export interface PartyOption {
  [key: string]: any
  id: number
  party_name: string
  current_balance: number
  debit: number
  credit: number
  net_balance: number
  nameCode: string
}

export interface AutoVatavFormData {
  date: string
  sender_id: PartyOption | null | Number
  receiver_id: PartyOption | null
  amount: string
  vatav: any
  sender_vatav: string
  receiver_vatav: string
  remarks: string
}

export const getParty = (): Promise<any> => {
  return axios.get(`${Party_URL}`).then((d: AxiosResponse<any>) => d.data)
}

export const getCommissionData = (data: any): Promise<any> => {
  return axios.post(`${MESSAGE_URL}/getCommissionData`, data, {
    headers: { "Content-Type": "application/json","Accept": "application/json" }
  }).then((d: AxiosResponse<any>) => d.data);
};


export const fetchSenderOptionsAPI = async (): Promise<PartyOption[]> => {
  return [
    {id: 1, party_name: 'Sender Party 1', current_balance: 1000, debit: 200, credit: 0, net_balance: 800, nameCode: "sender"},
    {
      id: 2,
      party_name: 'Sender Party 2',
      current_balance: 2000,
      debit: 400,
      credit: 0,
      net_balance: 1600,
      nameCode: "sender"
    },
    {
      id: 3,
      party_name: 'Sender Party 3',
      current_balance: 3000,
      debit: 600,
      credit: 0,
      net_balance: 2400,
      nameCode: "sender"
    },
  ]
}

export const fetchReceiverOptionsAPI = async (): Promise<PartyOption[]> => {
  // Dummy data for now, replace with actual API call later
  return [
    {
      id: 4,
      party_name: 'Receiver Party 1',
      current_balance: 500,
      debit: 0,
      credit: 100,
      net_balance: 400,
      nameCode: "sender"
    },
    {
      id: 5,
      party_name: 'Receiver Party 2',
      current_balance: 1500,
      debit: 0,
      credit: 300,
      net_balance: 1200,
      nameCode: "sender"
    },
    {
      id: 6,
      party_name: 'Receiver Party 3',
      current_balance: 2500,
      debit: 0,
      credit: 500,
      net_balance: 2000,
      nameCode: "sender"
    },
  ]
}

export const fetchPartyDetailsAPI = async (partyId: number): Promise<PartyOption> => {
  // Dummy implementation for now, replace with actual API call later
  return {
    id: partyId,
    party_name: `Party ${partyId}`,
    current_balance: 1000 * partyId,
    debit: 100 * partyId,
    credit: 50 * partyId,
    net_balance: 850 * partyId,
    nameCode: "sender"
  }
}

export const fetchCommissionDataAPI = async (
  senderId: number,
  receiverId: number,
  amount: string,
  senderVatav: string,
  receiverVatav: string
): Promise<any> => {
  // Dummy implementation for now, replace with actual API call later
  return {
    sender_current_balance: 6729762,
    receiver_current_balance: -74693,
    sender_debit: 1,
    receiver_credit: -1,
    sender_net_balance: 6729763,
    receiver_net_balance: -74817,
    vatav: 0,
  }
}

export const submitAutoVatavFormAPI = async (formData: any) => {
  return axios.post(`${MESSAGE_URL}/addAutoandNormalEntry`, formData, {
    headers: { "Content-Type": "application/json", "Accept": "application/json" }
  });
}

